import React, {useEffect, useState} from 'react';
import bn from "../utils/bemnames";
import {_t} from "../utils/translations";
import ImgWithDefault from './ImgWithDefault';
import CountryFlag from "./CountryFlag";

interface IProps {
  loading?: boolean;
  options: IItem[],
  onChange: (value: string | number) => void;
  placeholder?: string;
  valueDefault?: number;
  isNationalTeam?: boolean;
}

export interface IItem {
  title: string;
  value: string | number;
  imageUrl?: string;
  regionName?: string;
}

const bem = bn.create('dropdown');

const Dropdown: React.FC<IProps> = (props) => {
  const {
    onChange,
    options,
    loading = undefined,
    placeholder = undefined,
    valueDefault = null,
    isNationalTeam,
  } = props;
  const [value, setValue] = useState<number | null>(valueDefault);
  const [selectedItem, setSelectedItem] = useState<IItem | null>(null);
  const [visibleOptions, setVisibleOptions] = useState<Boolean>(false);

  useEffect(() => {
    setSelectedItem(options.find(option => option.value === value) ?? null);
  }, [options, value]);

  return (
    <div className={bem.b()}>
      <div
        className={bem.e('selected')}
        onClick={() => {
        setVisibleOptions(!visibleOptions)
        }}
      >
        {isNationalTeam && selectedItem?.regionName ? (
          <CountryFlag
            regionName={selectedItem.regionName}
            className={bem.e('competitor-logo')}
          />
        ) : (
          <>
            {selectedItem?.imageUrl && (
              <ImgWithDefault
                src={selectedItem.imageUrl}
                alt="logo"
                className={bem.e('logo')}
                style={{height: '28px'}} // Legacy TVG site fix
              />
            )}
          </>
        )}

        <div className={bem.e('selected-text')}>{_t(selectedItem?.title ?? placeholder ?? '-')}</div>
        {options.length > 0 && (
          <div
            className={visibleOptions ? `${bem.e('selected-arrow')} ${bem.e('selected-arrow--up')}` : bem.e('selected-arrow')}>
            <span/>
          </div>
        )}
      </div>
      {options.length > 0 && visibleOptions && <div className={bem.e('options')}>
        {options.map((option, index) => {
          return (
            <div
              className={`${bem.e('option')} ${selectedItem?.value === option.value ?? bem.e('option--active')}`}
              key={index}
              onClick={() => {
                if (!loading) {
                  setValue(option.value as number);
                  onChange(option.value as number)
                  setVisibleOptions(false)
                }
              }}
            >
              {isNationalTeam && option.regionName ? (
                <CountryFlag
                  regionName={option.regionName}
                  className={bem.e('competitor-logo')}
                />
              ) : (
                <>
                  {option.imageUrl !== undefined && (
                    <ImgWithDefault
                      src={option.imageUrl}
                      alt="logo"
                      className={bem.e('logo')}
                      style={{height: '28px'}} // Legacy TVG site fix
                    />
                  )}
                </>
              )}
              {_t(option.title)}
            </div>
          )
        })}
      </div>}
    </div>
  )
}

export default Dropdown;
